import { render, staticRenderFns } from "./reportCrawler.vue?vue&type=template&id=50a4d7fe"
import script from "./reportCrawler.vue?vue&type=script&lang=js"
export * from "./reportCrawler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports